// Board area = optional PDF backdrop + the shared drawing surface on top.
// KEEP IN SYNC with the dashboard original.
import { useState } from "react";
import BoardCanvas from "./BoardCanvas";
import PdfBackdrop from "./PdfBackdrop";
import { MAIN_BOARD, pdfBoardId } from "../wsProtocol";

const Board = ({ pdf, boardsRef, subscribe, send, canDraw, tool, isTeacher, textPromptLabel, backgrounds = {}, children }) => {
    const [pdfAspect, setPdfAspect] = useState(16 / 9);
    const isPdfMode = Boolean(pdf && pdf.url);
    const aspect = isPdfMode ? pdfAspect : 16 / 9;
    const boardId = isPdfMode ? pdfBoardId(pdf.url, pdf.page) : MAIN_BOARD;
    const bg = backgrounds[boardId] || "white";

    return (
        <div
            style={{
                position: "relative",
                // keep the page's true aspect: cap the width so the height
                // never exceeds 78vh instead of squashing the content
                width: `min(100%, calc(78vh * ${aspect}))`,
                aspectRatio: `${aspect}`,
                margin: "0 auto",
                borderRadius: 8,
                overflow: "hidden",
                boxShadow: "0 1px 8px rgba(0,0,0,0.15)",
                backgroundColor: "#fff",
            }}
        >
            {isPdfMode && (
                <PdfBackdrop url={pdf.url} page={pdf.page} onAspect={setPdfAspect} />
            )}
            <div style={{ position: "absolute", inset: 0 }}>
                <BoardCanvas
                    boardId={boardId}
                    boardsRef={boardsRef}
                    subscribe={subscribe}
                    send={send}
                    canDraw={canDraw}
                    tool={tool}
                    isTeacher={isTeacher}
                    textPromptLabel={textPromptLabel}
                    bg={bg}
                    transparent={isPdfMode}
                />
            </div>
            {children}
        </div>
    );
};

export default Board;
